package dev.lingvo.site.components.studio.editor

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import dev.lingvo.site.ds.Space
import dev.lingvo.site.ds.TypeScale
import dev.lingvo.site.ds.toSitePalette
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
internal fun StudioMetaText(value: String) {
    val palette = ColorMode.current.toSitePalette()
    Span(attrs = { attr("data-studio-meta", ""); style {
        property("color", palette.textMuted.toString()); property("font-size", TypeScale.Small.toString())
    } }) { Text(value) }
}

/** The separator survives textContent and assistive reading even though the layout supplies gaps. */
@Composable
internal fun StudioNameStatus(name: String, status: String) {
    Span(attrs = { style {
        property("display", "inline-flex"); property("align-items", "baseline"); property("flex-wrap", "wrap")
        property("gap", Space.SM.toString()); property("min-width", "0"); property("overflow-wrap", "anywhere")
    } }) {
        Span { Text(name) }
        if (status.isNotEmpty()) {
            Span(attrs = { style {
                property("position", "absolute"); property("width", "1px"); property("height", "1px")
                property("overflow", "hidden"); property("clip-path", "inset(50%)")
            } }) { Text(", ") }
            StudioMetaText(status)
        }
    }
}
